import React from 'react';

const inputCls = (hasError) =>
  `w-full bg-slate-50 border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-600/5 focus:border-indigo-600 transition-all outline-none text-slate-900 font-medium placeholder:text-slate-300 ${hasError ? 'border-red-400' : 'border-slate-200'}`;

const FieldLabel = ({ field }) => (
  <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide" htmlFor={field._id}>
    {field.label || field.name}
    {field.required && <span className="text-rose-500 ml-1">*</span>}
  </label>
);

const TextField = ({ field, value, onChange, status }) => (
  <div className="space-y-1.5">
    <FieldLabel field={field} />
    {field.description && <p className="text-[10px] text-slate-400 font-medium leading-relaxed">{field.description}</p>}
    <input
      id={field._id}
      name={field.name}
      type="text"
      value={value || ''}
      onChange={onChange}
      placeholder={field.placeholder || 'Enter text...'}
      className={inputCls(status === 'error')}
    />
  </div>
);

export { inputCls, FieldLabel };
export default TextField;
